import introImgAsset from "@/assets/intro-lifestyle-beach.webp.asset.json";
import { CurtainImage, RevealBlock } from "@/components/RevealEffects";

const pillars = [
  { title: "Science-Based", description: "Grounded in cardiometabolic research, human biology, and traditional food systems." },
  { title: "Concierge & Personalized", description: "Every program shaped around your current health, preferences, and daily responsibilities." },
  { title: "Measurable Outcomes", description: "Progress is followed through meaningful indicators - not motivation alone." },
];

const IntroSection = () => (
  <section className="bg-secondary py-20 md:py-32 lg:py-40 overflow-hidden">
    <div className="mx-auto max-w-[1496px] px-6 md:px-12 lg:px-[100px]">
      <RevealBlock className="relative md:grid md:items-center">
        <CurtainImage
          src={introImgAsset.url}
          alt="Couple walking arm in arm along the shoreline on a sunny beach"
          wrapperClass="w-full md:col-start-1 md:row-start-1 md:w-[70%] md:justify-self-end md:self-stretch"
          className="h-[430px] w-full object-cover md:h-full md:min-h-[680px]"
        />
        <RevealBlock
          variant="rise"
          index={2}
          className="relative -mt-20 w-[92%] bg-background px-7 py-10 md:col-start-1 md:row-start-1 md:my-16 md:mt-16 md:w-[46%] md:justify-self-start md:px-12 md:py-14"
        >
          <p className="eyebrow mb-5 text-nav-cta">With Every Program</p>
          <h2 className="mb-6 text-foreground">Lifestyle is Medicine. <span className="text-nav-cta">The Science of Longevity.</span></h2>
          <p className="text-muted-foreground">
            Most people who come to Wellness Academy USA are not starting from zero. They are already eating, moving, working, traveling, and doing their best to take care of themselves - but the pieces often feel disconnected. We create personalized, concierge lifestyle programs for adults who want to improve cardiometabolic health, lose weight sustainably, regain strength and energy, and protect the years ahead. Based in San Diego and available remotely across the United States, our work integrates whole-food nutrition, functional movement, sleep and recovery, stress regulation, and science-backed behavior change.
          </p>
        </RevealBlock>
      </RevealBlock>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 pt-16 sm:grid-cols-3 md:gap-12 md:pt-28">
        {pillars.map((pillar, i) => (
          <RevealBlock key={pillar.title} variant="rise" index={i} className="border-t-2 border-nav-cta/60 pt-6">
            <h3 className="mb-2 text-foreground">{pillar.title}</h3>
            <p className="text-muted-foreground">{pillar.description}</p>
          </RevealBlock>
        ))}
      </div>
    </div>
  </section>
);

export default IntroSection;
